import React, { useEffect, useState } from 'react'
import { Theme, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { Tab } from '../../../screens/User/UserDashboard/components/DashboardNetworkContentTabs'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes'
import { useSelector } from 'react-redux'
import { getLicensePermissions } from '../../../store/common/common.selectors'

export interface Submenudata {
  id: string
  label: string
}

interface ITabsProps {
  activeItem?: NetworkType
  tabs: Tab[]
  onChangeTab?: (key: NetworkType) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  tabMenuMargin: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  subMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1, 4),
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  subMenuText: {
    whiteSpace: 'nowrap',
    fontSize: '15px',
    height: '20px',
  },
  activeItem: {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '& svg': {
      fill: theme.palette.primary.main,
    },
  },
  disabled: {
    color: theme.palette.text.disabled,
    pointerEvents: 'none',
    '& svg': {
      fill: theme.palette.text.disabled,
    },
  },
  inactiveItem: {
    color: theme.palette.text.primary,
    '&:hover': {
      borderBottom: `3px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      '& svg': {
        fill: theme.palette.primary.main,
      },
    },
  },
}))

const TabMenu: React.FC<ITabsProps> = (props) => {
  const classes = useStyles()

  const [tabs, setTabs] = useState<Tab[]>([])
  const [activeItem, setActiveItem] = useState<NetworkType>()
  const [disabledTabs, setDisabledTabs] = useState<NetworkType[]>()

  const licensePermissions: SocialNetworkLicensePermissions = useSelector(getLicensePermissions)

  const isDisabled = (activeItem: NetworkType) => {
    return disabledTabs?.find(item => item === activeItem)
  }

  useEffect(() => {
    const disabledTabs: NetworkType[] = []
    if (!licensePermissions.facebook) {
      disabledTabs.push(NetworkType.Facebook)
    }
    if (!licensePermissions.instagram) {
      disabledTabs.push(NetworkType.Instagram)
    }
    if (!licensePermissions.googleMyBusiness) {
      disabledTabs.push(NetworkType.GoogleMyBusiness)
    }
    if (!licensePermissions.linkedIn) {
      disabledTabs.push(NetworkType.LinkedIn)
    }
    setDisabledTabs(disabledTabs)
  }, [licensePermissions])

  useEffect(() => {
    props.tabs && setTabs(props.tabs)
  }, [props.tabs])

  useEffect(() => {
    setActiveItem(props.activeItem)
  }, [props.activeItem])

  return (
    <Grid container spacing={1} className={classes.tabMenuMargin}>
      {tabs.map((tab: Tab, index) => {
        const setClassStatus = activeItem === tab.name ? classes.activeItem : isDisabled(tab.name) ? classes.disabled : classes.inactiveItem
        return (
          <Grid key={index} item>
            <div
              className={`${classes.subMenu} ${setClassStatus}`}
              onClick={() => {
                props.onChangeTab && props.onChangeTab(tab.name)
              }}
            >
              {tab.icon}
              <Typography className={classes.subMenuText}>{tab.label}</Typography>
            </div>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default TabMenu
